import { render } from "./ChooseAvatar.vue?vue&type=template&id=c10fac8c"
import script from "./ChooseAvatar.vue?vue&type=script&lang=js"
export * from "./ChooseAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__